import B_Real from '../../../../base/dev/child/base/B_Real';
import B_ChildWorld from '../../../../base/dev/child/base/B_ChildWorld';
import B_Image from '../../../../base/dev/child/image/B_Image';
import B_GridChild from '../../../../base/dev/child/grid/B_GridChild';
import R_GridChild from '../grid/R_GridChild';
import R_Define from '../../util/R_Define';
import MixinBuilder from '../../../../base/dev/scripts/MixinBuilder';
import B_Define from '../../../../base/dev/util/B_Define';

const mix = superclass => new MixinBuilder(superclass);

const init = () => {
    return class R_ImageGrid extends mix(B_Real).with(
        B_ChildWorld, B_Image, B_GridChild, R_GridChild
    ) {
        // 회전 애니메이션이 실행 중인가
        constructor(obj) {
            super(obj);

            this._position = obj.position || 'mid';
            this._rotate = !!obj.rotate;
            this._isRotate = false;

            if (
                this._rotate
                && obj.x <= Object.values(this.CODMOS.WORLD.LIST[B_Define.GRID_TYPE])[0].column
            ) {
                this.rotate();
            }

            this._moveLeftPx = 0;
        }

        /**
         * [ Function :: rotate ]
         *
         * @DES :: 회전 이벤트 실행
         * @O.P :: null
         */
        rotate() {
            // 만약 속도가 0이면 중단
            if (this.CODMOS.speed) {
                this._isRotate = true;
                setTimeout(() => {
                    this._object.rotation -= 30;
                    if (this._visible) this.rotate();
                }, 150 / this.CODMOS.speed);
            } else {
                this._isRotate = false;
            }
        }

        /**
         * [ Function :: moveToLeft ]
         *
         * @DES :: pixelX 좌측으로 이동
         * @IP1 :: px {number}
         * @O.P :: null
         */
        moveToLeft(px) {
            this._pixelX -= px;
        }

        /**
         * [ Function :: moveToRight ]
         *
         * @DES :: pixelX 우측으로 이동
         * @IP1 :: px {number}
         * @O.P :: null
         */
        moveToRight(px) {
            this._pixelX += px;
        }

        // 히어로와 닿았는지 판단
        get isHitHero() {
            let rtn = false;
            const [hero] = Object.values(this.CODMOS.WORLD.LIST[R_Define.HERO_TYPE]);
            if (hero._gridX === this._gridX) {
                switch (this._position) {
                    case 'top': {
                        if (hero._isOnJump) rtn = true;
                        break;
                    }
                    case 'mid': {
                        if (!hero._isOnSlide) rtn = true;
                        break;
                    }
                    case 'bottom': {
                        if (!hero._isOnJump) rtn = true;
                        break;
                    }
                    default:
                }
            }
            return rtn;
        }
    };
};


export default init();



// WEBPACK FOOTER //
// ./src/assets/js/codmos/game/lcPlugIn/canvas/runner/dev/child/image/R_ImageGrid.js